import { render, staticRenderFns } from "./setWorker.vue?vue&type=template&id=76a87658"
import script from "./setWorker.vue?vue&type=script&lang=js"
export * from "./setWorker.vue?vue&type=script&lang=js"
import style0 from "./setWorker.vue?vue&type=style&index=0&id=76a87658&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports